<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  styleClass="message-dialog"
  header="Notification Message"
  [style]="{ width: '50vw', minWidth: '320px', maxWidth: '800px' }"
  (onHide)="hide()"
>
  @if (messageData(); as data) {
  <div class="message-content">
    <!-- Header with type and metadata -->
    <div class="message-header">
      <div class="type-badge">
        <p-badge
          [value]="data.type"
          [severity]="getTypeSeverity(data.type)"
          size="large"
        >
        </p-badge>
      </div>

      @if (data.dateTime || data.project || data.service) {
      <div class="metadata">
        @if (data.dateTime) {
        <div class="metadata-item">
          <i class="pi pi-calendar"></i>
          <span>{{ data.dateTime }}</span>
        </div>
        } @if (data.project) {
        <div class="metadata-item">
          <i class="pi pi-folder"></i>
          <span>{{ data.project }}</span>
        </div>
        } @if (data.service) {
        <div class="metadata-item">
          <i class="pi pi-cog"></i>
          <span>{{ data.service }}</span>
        </div>
        }
      </div>
      }
    </div>

    <p-divider></p-divider>

    <!-- Subject section -->
    <div class="subject-section">
      <h4 class="section-title">
        <i class="pi pi-info-circle"></i>
        Subject
      </h4>
      <p-card class="subject-card">
        <div class="subject-content">
          <p class="subject-text">{{ data.subject }}</p>
          <button
            pButton
            type="button"
            icon="pi pi-copy"
            class="p-button-text p-button-sm copy-btn"
            pTooltip="Copy subject"
            tooltipPosition="top"
            (click)="copySubject()"
          ></button>
        </div>
      </p-card>
    </div>

    <p-divider></p-divider>

    <!-- Message content -->
    <div class="message-section">
      <h4 class="section-title">
        <i class="pi pi-comment"></i>
        Message
      </h4>
      <p-card class="message-card">
        <div class="message-text-content">
          <pre class="message-text">{{ data.message }}</pre>
          <button
            pButton
            type="button"
            icon="pi pi-copy"
            class="p-button-text p-button-sm copy-btn"
            pTooltip="Copy message"
            tooltipPosition="top"
            (click)="copyMessage()"
          ></button>
        </div>
      </p-card>
    </div>
  </div>
  }

  <!-- Footer with actions -->
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Copy Message"
        icon="pi pi-copy"
        class="p-button-outlined"
        (click)="copyMessage()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
